import { Menu, Text } from '@mantine/core';
import { Icon } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/shallow';

import { ShortcutAction } from 'app/modules/wallforming/components/scenes/toolbar/types/shortcutAction';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const SelectAll = () => {
    const { t } = useTranslation();

    const { selectAllArticleInstances, articles } = usePlacementStore(
        useShallow((state) => ({
            selectAllArticleInstances: state.selectAllArticleInstances,
            articles: state.articles
        }))
    );

    const anyObjectsPlaced = Object.values(articles).some(
        (article) => Object.keys(article.articleInstances).length > 0
    );

    return (
        <Menu.Item
            disabled={!anyObjectsPlaced}
            leftSection={
                <Icon className="action-menu-entry-decoration action-menu-entry-decoration-icon" icon="select_all" />
            }
            rightSection={
                <Text className="action-menu-entry-decoration-text text-right text-[13px]">{ShortcutAction.SelectAll}</Text>
            }
            onClick={() => selectAllArticleInstances()}
        >
            {t('selectAll')}
        </Menu.Item>
    );
};
